<template lang="pug">
div
    grid-table-component(
        :headers='headers',
        :data='paginacao.solicitacoes',
        :is-paginated='true',
        :is-loading='isLoading',
        :pagination='setPagination()',
        @table:page-changed='checkPaginationChange($event)'
        @table:items-per-page-changed='onItemsPerPageChange'
    )
        template(v-slot:selecionado='{ item }')
            checkbox-input-component(v-model='item', v-if='item.condicao === "AGUARDANDO_ANALISE"') 

        template(v-slot:codigoImovel='{ item }')
            span(v-tooltip='{ label: item.codigoImovel, position: "bottom", minWidth: "360px" }') {{ item.codigoImovel | ellipsis(6, 4) }}

        template(v-slot:copiarCodigoImovel='{ item }')
            span(v-tooltip='{ label: "Copiar", position: "bottom", minWidth: "30px" }')
                button-component.copy-button(
                    label='',
                    icon='mdi-content-copy',
                    color='green',
                    @click.native='copyClipboard(item)'
                )

        template(v-slot:municipio="{ item }")
            span {{ item.municipio || 'Não informado' }}

        template(v-slot:dataSolicitacao='{ item }')
            span {{ item.dataSolicitacao | data }}

        template(v-slot:areaTotalCompensar='{ item }')
            span {{ item.areaTotalCompensar | decimal }}

        template(v-slot:areaTotalRecompor='{ item }')
            span {{ item.areaTotalRecompor | decimal }}

        template(v-slot:condicaoInscricao='{ item }')
            span {{ getCondicaoInscricaoLabel(item.condicaoInscricao) }}

        template(v-slot:condicao='{ item }')
            .actions-check
                chip-component(
                    :label='getConditionLabel(item.condicao).label',
                    :background-color='getConditionLabel(item.condicao).chipColor'
                    width='150px'
                )

        template(v-slot:acoes='{ item }')
            .actions-check
                dropdown-component(
                    :list='montarAcoes(item.acoes)',
                    @input='onAction($event, item)',
                    :props='{ label: "nome" }',
                    :is-select='false',
                    position='left'
                )

    modal-component(
        v-if='modalAnaliseSolicitacao',
        title='Solicitação de envio do Monitoramento PRADA',
        @close='modalAnaliseSolicitacao = false'
        width='42rem'
    )
        ModalAnaliseSolicitacao(
            @close='fecharModal',
            @atualizar='atualizar',
            :solicitacoes='solicitacoesSelecionadas', 
            :modoLeitura='modoLeitura'
        )
</template>

<script>
import { AcaoEnum, CondicaoValidacaoEnum, CondicaoInscricaoEnum } from '@/enums/processo.enum.js';
import { StatusImovelEnum } from '@/enums/status-imovel.enum';
import { listarSolicitacoesEnvioMonitoramento } from '@/services/solicitacao-envio-monitoramento.service';
import ModalAnaliseSolicitacao from '@/views/monitoramento/components/ModalAnaliseSolicitacao.vue';


export default {
    name: 'CaixaEntradaTableComponent',

    components: {
        ModalAnaliseSolicitacao
    },

    data() {
        return {
            StatusImovelEnum,
            modalAnaliseSolicitacao: false,
            headers: [
                { text: '', field: 'selecionado', maxWidth: '40px' },
                { text: 'CAR', field: 'codigoImovel', maxWidth: '' },
                { text: '', field: 'copiarCodigoImovel', maxWidth: '' },
                { text: 'Município', field: 'municipio', maxWidth: '' },
                { text: 'Envio da solicitação', field: 'dataSolicitacao', maxWidth: '' },
                { text: 'Área a compensar (ha)', field: 'areaTotalCompensar', maxWidth: '' },
                { text: 'Área a recompor (ha)', field: 'areaTotalRecompor', maxWidth: '' },
                { text: 'Fase do processo', field: 'condicaoInscricao', maxWidth: '' },
                { text: 'Condição', field: 'condicao', maxWidth: '' },
                { text: 'Ações', field: 'acoes', sortable: false, maxWidth: '' },
            ],
            paginacao: {
                total: 0,
                pagina: 1,
                numeroPaginas: 0,
                quantidadePagina: 10,
                solicitacoes: [],
            },
            aprovadoOptions: [
                { id: 'APROVADO', label: 'Aprovado' },
                { id: 'REPROVADO', label: 'Reprovado' },
            ],
            solicitacoesSelecionadas: [],
            isLoading: true,
            modoLeitura: false,
        };
    },
    mounted() {
        this.pesquisar({
            uf: 'SP',
            pagina: 1,
            quantidadePagina: 10,
        });
    },
    methods: {
        montarAcoes(acoes) {
            return acoes.map((acao) => AcaoEnum[acao]);
        },
        async onAction(event, solicitacao) {
            const solicitacoes = this.paginacao.solicitacoes.filter(s => s.selecionado === true);
            this.solicitacoesSelecionadas = solicitacoes.length > 0 ? solicitacoes : [solicitacao];

            if (solicitacao.condicao !== 'AGUARDANDO_ANALISE') {
                this.solicitacoesSelecionadas = [solicitacao];
                this.modoLeitura = true;
            } else {
                this.modoLeitura = false;
            }

            switch (event.id) {
                case AcaoEnum.ANALISAR_SOLICITACAO_ENVIO_MONITORAMENTO.id:
                case AcaoEnum.VISUALIZAR_ANALISE_SOLICITACAO_ENVIO_MONITORAMENTO.id:
                    this.modalAnaliseSolicitacao = true;
                    break;
                default:
                    break;
            }
        },
        async pesquisar(filtro) {
            this.isLoading = true;
            this.paginacao = {
                solicitacoes: [],
            };

            try {
                this.paginacao = await listarSolicitacoesEnvioMonitoramento(filtro);
            } catch (error) {
                console.error('Erro ao listar monitoramento:', error);
            } finally {
                this.isLoading = false;
            }
        },
        checkPaginationChange({ page }) {
            this.$emit('inbox:page-change', page);
        },
        onItemsPerPageChange(itemsPerPage) {
            this.$emit('inbox:items-per-page-change', itemsPerPage);
        },
        setPagination() {
            return {
                page: this.paginacao.pagina,
                totalPages: this.paginacao.numeroPaginas,
                itemsPerPage: this.paginacao.quantidadePagina,
                totalItems: this.paginacao.total,
                order: 'ASC',
            };
        },
        getConditionLabel(condicao) {
            const condicaoEnum = CondicaoValidacaoEnum[condicao] || {};
            return {
                label: condicaoEnum.nome,
                chipColor: condicaoEnum.style.chip.color,
            };
        },
        getCondicaoInscricaoLabel(idCondicaoInscricao) {
            const condicaoInscricao = Object.values(CondicaoInscricaoEnum).find(item => item.id === idCondicaoInscricao);
            return condicaoInscricao ? condicaoInscricao.label : 'Desconhecido';
        },
        copyClipboard(item) {
            navigator.clipboard.writeText(item.codigoImovel);
            this.$toast({
                showClose: true,
                message: 'Código Copiado',
                type: 'success'
            });
        },
        fecharModal() {
            this.modalAnaliseSolicitacao = false;
            this.solicitacoesSelecionadas = [];
        },
        atualizar() {
            this.pesquisar({
                uf: 'SP',
                pagina: 1,
                quantidadePagina: 10,
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.copy-button {
    background-color: transparent !important;
    box-shadow: none !important;
}

.status-imovel {
    padding: 3px 5px;
    border-radius: 2px;
    font-size: 9px;
}
</style>

